import React, { FC, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { ModalDialog } from "@/components/molecules";
import { Request, RequestDocument } from "@/shared/domain";
import { useMediaDisplayer } from "@/shared/hooks";
import { getLink } from "@/shared/utils";
import * as tagManager from "@/tagManager";

import RequestDocumentList from "../RequestDocumentList/RequestDocumentList";

type RequestModalProps = {
    request: Request;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const RequestModal: FC<RequestModalProps> = ({ request, open, setOpen }) => {
    const { t } = useTranslation();
    const [requestDocuments, setRequestDocuments] = useState<MyBrokerApi.RequestDocument[]>([]);
    const { displayFullMode } = useMediaDisplayer();

    const onCloseModal = () => {
        setRequestDocuments([]);
        setOpen(false);
    };

    const handleOpenDocumentDisplayer = (document: RequestDocument) => {
        tagManager.pushViewItemEvent("documentRequest", "Requests Documents");
        const url = getLink(document, "content")?.href;

        displayFullMode({
            title: document.title,
            type: document.title.substring(document.title.lastIndexOf(".") + 1),
            url,
            onClose: () => onCloseModal(),
        });
    };

    useEffect(() => {
        if (open) {
            if (request.userRequestDocument.length > 1) {
                setRequestDocuments(request.userRequestDocument);
            } else {
                handleOpenDocumentDisplayer(request.userRequestDocument[0]);
            }
        }
    }, [open]);

    return (
        <>
            {!!requestDocuments.length && (
                <ModalDialog title={t("Common.Documents")} fullSize open onClose={onCloseModal}>
                    <RequestDocumentList documents={requestDocuments} onOpen={handleOpenDocumentDisplayer} />
                </ModalDialog>
            )}
        </>
    );
};

export default RequestModal;
